// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import breakpoints from "../base/breakpoints";

const mdUp = `@media (min-width: ${breakpoints.values.md}px)`;

const MuiPaper = {
  styleOverrides: {
    // Since we dont have customization in the theme.shadows property, these values were taken from the mui default theme
    root: {
      // elevation 0
      boxShadow: "none",
      [mdUp]: {
        // elevation 3
        boxShadow:
          "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
      },
    },
  },
};

export default MuiPaper;
